import script from "./MultipurposeImageBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipurposeImageBanner.vue?vue&type=script&setup=true&lang=js"

import "./MultipurposeImageBanner.vue?vue&type=style&index=0&id=4a655070&lang=scss"

const __exports__ = script;

export default __exports__